import { BRow } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBRow when migrating. */
export const EgBRow = createEgBootstrapProxy("EgBRow", BRow);
